import { AssetsMap, PokerTheme, LOCATION_TAKEN_TIME } from "Utils/Constants";
import pokerThemeJson from 'Assets/pokerThemeMap.json'
import assetsMapJson from 'Assets/PokerAssetsMap.json'
import { DEBUG, USER_COOKIE_NAME } from "../utilities/Constants";
import Cookies from "universal-cookie";

let pokerTheme = pokerThemeJson; // assigning to json for initial render
let assetsMap = assetsMapJson;

export function getLocalStorage(pl){
    if(window.localStorage){
        return window.localStorage.getItem(pl);
    }
}

export function setLocalStorage(name, value){
    if(window.localStorage){
        window.localStorage.setItem(name, value);
    }
}

export function getStoredTableAssets(){
    let value = getLocalStorage(USER_COOKIE_NAME+"assets");
    if(value)
        return JSON.parse(atob(value));
    else
        return "";
}

export function setTableAssets(config){
    const value = btoa(JSON.stringify(config));
    setLocalStorage(USER_COOKIE_NAME+'assets', value);
}

export function setLocationTakenData(data){
    setLocalStorage(LOCATION_TAKEN_TIME, JSON.stringify(data))
}

export function getLastLocationTakenData() {
    const cookies = new Cookies();
    let ldata = cookies.get(LOCATION_TAKEN_TIME, {
        'path': '/'
    });
    return ldata;
}

export function setAssets(theme, assets, callBack){ 
    pokerTheme = theme; // assigning values to be from S3
    assetsMap = assets;
    if(typeof callBack === "function")
        callBack();
}

export function setConfigCookie(config){
    const value = btoa(JSON.stringify(config));
    setLocalStorage(USER_COOKIE_NAME+'consumer', value);
}

export function getConfig(){
    let value = getLocalStorage(USER_COOKIE_NAME+"consumer");
    if(value)
        return JSON.parse(atob(value));
    else
        return "";
}

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function getTournamentSpeed(speedValue) {
    switch(speedValue) {
        case "slow":
            return {sf : "S", ff : "Slow"};
        case "normal":
            return {sf : "N", ff : "Normal"};
        case "turbo":
            return {sf : "T", ff : "Turbo"};
        case "hyper":
            return {sf : "H", ff : "Hyper"};
        case "hyper_turbo":
            return {sf : "HT", ff : "Hyper-Turbo"};
        case "regular":
            return {sf : "R", ff : "Regular"};
        default :
            return "";
    }
}

export function getTourneyEntryType(tourneyEntry, tournamentType) {
    if(tournamentType === 'mfp' || tournamentType === 'msp'){
        return {sm: "MF", abr: "Multi-Flight"};
    }
    else
        switch(tourneyEntry) {
            case "freeroll":
                return {sm : "FR", abr: "Freeroll"};
            case "re_buy":
                return {sm: "R", abr: "Rebuy"};
            case "freeze_out":
                return {sm: "FO", abr: "Freeze-Out"};
            case "re_buy_add_on":
                return {sm: "R+A", abr: "Rebuy+Addon"};
            case "re_entry":
                return {sm: "RE", abr: "Re-Entry"};
            default:
                return ""
        }
}

export function getMFColor(type){
    if(type === 'msp' || type === 'mfp')
        return "#f2e100";
    else    
        return "#00d123";
}

export function getMonth(date, length){
    const dateObj = new Date(date);
    let month = monthNames[dateObj.getMonth()]
    return length && month? month.substr(0,length) : month
}

export function getDate(date){
    const dateObj = new Date(date);
    return dateObj.getDate()
}


export function formatAMPM(date) {
    const dateObj = new Date(date);
    var hours = dateObj.getHours();
    var minutes = dateObj.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

function formatDate(date) {
    const dateObj = new Date(date);
    const month = dateObj.getMonth()+1;
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    const output = `${day}.${month}.${year}`;
    return output;
}

function monthFormatDate(timeValue) {
    const dateObj = new Date(timeValue);
    const month = monthNames[dateObj.getMonth()];
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    const output = `${day} ${month} ${year}`;
    return output;
}

export function getTourneyTimeStamp(timeValue) {
    let timeStamp = new Date(timeValue);
    let timeFormat = formatAMPM(timeStamp);
    let dayFormat = formatDate(timeValue);
    return `${timeFormat}, ${dayFormat}`;
}

export function getMonthDateFormat(timeValue) {
    let timeStamp = monthFormatDate(timeValue);
    return timeStamp;
}

export function lateRegisterationTimer(lateValue) {
    let timerValue = lateValue/1000;
    let timerText = "";
    setInterval(() => {
        timerValue = timerValue - 1;
        let seconds = parseInt(timerValue%60);
        let minutes = parseInt((timerValue/60)%60);
        let hours = parseInt((timerValue/(60*60)) % 24);
        timerText = `${hours}:${minutes}:${seconds}`;
    },1000, timerText)
    return timerValue;
}

export const scoreMap = {
    "announced": 8,
    "late_registration": 7,
    "registering": 6,
    "playing": 5,
    "registered": 4,
    "running": 3,
    "completed": 2,
    "canceled": 1
};

export function mapMyStyles(searchNode) {
    let themeJson = pokerTheme.pokerLobbyWebTheme[searchNode]
    if(!themeJson){
        let localThemeJson = pokerThemeJson.pokerLobbyWebTheme[searchNode]
        return localThemeJson
    }
    return themeJson
}

export function mapMyMobileStyle(searchNode){
    if(!searchNode){
        return false
    }
    let themeJson = pokerTheme.pokerLobbyMobileTheme[searchNode]
    if(!themeJson){
        let localThemeJson = pokerThemeJson.pokerLobbyMobileTheme[searchNode]
        return localThemeJson
    }
    return themeJson
}

export function imagesMap(seachImg) {
    let img = assetsMap.images[seachImg]  
    if(!seachImg) return "";
    if(!img || !img.includes('http')){
        let localImg = assetsMapJson.images[seachImg];
        if(!localImg)
            return "";
        return require(`AssetsImgs/${localImg}`);
    }
    return img
}
export function soundsMap(seachSound) {
    let sound = assetsMap.sounds[seachSound]  
    if(!seachSound || !sound) return ""
    if(!sound || !sound.includes('http')){
        let localSound = assetsMapJson.sounds[seachSound];
        return require(`AssetsAudio/${localSound}`);
    }
    return sound
}

export function fontList(){
  let type = ""
  let fonts = pokerTheme.fonts
  Object.keys(fonts).map((key) => {
    type += `@font-face{ font-family:${key}; src:url(${fonts[key]}); }`
    return null
  })
    return type
}

export function setClevertapProfile(pl) {
    if (window.clevertap) {
        try {
            const payload = {
                Site: {
                    ...pl,
                },
            };
            window.clevertap.onUserLogin.push(payload);
        } catch (error) {
            console.log(error);
        }
    }
} 

export function checkEVCCookie(){
    let count = getLocalStorage(USER_COOKIE_NAME+"EVC");
    if(!count) {
        setLocalStorage(USER_COOKIE_NAME+"EVC", 3);
        return true;
    }
    else {
        if(count > 1){
            count -= 1;
            setLocalStorage(USER_COOKIE_NAME+"EVC", count);
            return true;
        } else{
            return false;
        }
    }
}

export function getSessionTimeDiff(duration) {
    let seconds = Math.floor((duration / 1000) % 60);
    let minutes = Math.floor((duration / (1000 * 60)) % 60);
    let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
  
    return hours + ":" + minutes + ":" + seconds;
}